import { Core as YubinBango } from "yubinbango-core2";

export default () => {
  const form = document.querySelector(".snow-monkey-form");
  if (!form) {
    return;
  }
  formInit(form);

  // Snow Monkey formsのバリデーション処理後対策
  form.addEventListener("smf.invalid", (event) => {
    formInit(form);
  });
};

const formInit = (form) => {
  /**
   * ご連絡希望時間の切替
   */
  const contactRadios = form.querySelectorAll(
    'input[type="radio"][name="contact"]'
  );
  const desiredTime = form.querySelector(".desired-time");
  contactRadios.forEach((contactRadio) => {
    contactRadio.addEventListener("change", (event) => {
      console.log("切替", event.target.value);
      if (event.target.value === "お電話") {
        desiredTime.style.display = "block";
        desiredTime.querySelector('input[name="desired-time"]').required = true;
      } else {
        desiredTime.style.display = "none";
        desiredTime.querySelector(
          'input[name="desired-time"]'
        ).required = false;
        desiredTime.querySelector('input[name="desired-time"]').value = null;
      }
    });
  });

  /**
   * 郵便番号から住所自動入力
   * Snow Monkey forms
   */
  form.classList.add("h-adr");
  const yubinBangoTag =
    '<span class="p-country-name" style="display:none;">Japan</span>';
  form.insertAdjacentHTML("afterbegin", yubinBangoTag);
  const hadrs = document.getElementsByClassName("h-adr");
  const inputZip = form.querySelector(".p-postal-code");
  // 入力ボタン
  //   const buttonInputAddr = form.querySelector(".p-postal-button > a");
  //   buttonInputAddr.addEventListener("click", (event) => {
  //     event.preventDefault();
  //     updateAddr();
  //   });
  //   inputZip.addEventListener("blur", (event) => {
  //     updateAddr();
  //   });
  inputZip.addEventListener("change", (event) => {
    updateAddr();
  });
  inputZip.addEventListener("keyup", (event) => {
    updateAddr();
  });

  const updateAddr = (event) => {
    const zipCode = inputZip.value;
    if (!zipCode.match(/^[0-9]{3}-?[0-9]{4}$/)) {
      return false;
    }
    const addr = document.querySelector(".p-region");
    new YubinBango(zipCode, (value) => {
      addr.value =
        value.region + value.locality + value.street + value.extended;
    });
  };
};
